module.exports = __webpack_public_path__ + "asset/fullScreen_1Omo0Sw5.png";